import baseAPI from "@/http";

const router = "api/selo/revisoes-tecnicas";

const buildFormData = (payload) => {
  const formData = new FormData();

  Object.keys(payload).forEach((key) => {
    const value = payload[key];

    if (value === undefined || value === null) {
      return;
    }

    if (key === "arquivos" && Array.isArray(value)) {
      value.forEach((file) => {
        formData.append("Arquivos", file);
      });
      return;
    }

    formData.append(key, value);
  });

  return formData;
};

export const technicalReviewAPI = {
  context: (municipioId) => baseAPI.get(`${router}/municipio/${municipioId}/contexto-nacional`),
  list: (municipioId) => baseAPI.get(`${router}/municipio/${municipioId}`),
  stateDashboard: (payload) => baseAPI.post(`${router}/dashboard`, payload),
  criteria: (municipioId) =>
    baseAPI.get(`${router}/municipio/${municipioId}/criterios`),
  evidences: (municipioId, perguntaId) =>
    baseAPI.get(
      `${router}/municipio/${municipioId}/criterios/${perguntaId}/evidencias`
    ),
  get: (id) => baseAPI.get(`${router}/${id}`),
  create: (payload) =>
    baseAPI.post(router, buildFormData(payload), {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  update: (id, payload) =>
    baseAPI.put(`${router}/${id}`, buildFormData(payload), {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  send: (id, payload) => baseAPI.post(`${router}/${id}/enviar`, payload),
  cancel: (id, payload) => baseAPI.post(`${router}/${id}/cancelar`, payload),
  comment: (id, payload) =>
    baseAPI.post(`${router}/${id}/comentarios`, payload),
  changeStatus: (id, payload) =>
    baseAPI.post(`${router}/${id}/status`, buildFormData(payload), {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  downloadAttachment: (anexoId) =>
    baseAPI.get(`${router}/anexos/${anexoId}`, { responseType: "blob" }),
  downloadEvidence: (evidenceId) => {
    // Sempre usar responseType blob, pois só chama quando não tem URL
    return baseAPI.post(`api/arquivo/evidencia/download/${evidenceId}`, {}, {
      responseType: "blob",
    });
  },
  deleteAttachment: (anexoId) => baseAPI.delete(`${router}/anexos/${anexoId}`),
};
